(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bethesda-form"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {

  if (document.getElementById('bethesda-form-hide')) {
    document.getElementById('bethesda-form-hide').addEventListener("submit", action, false);
  }

  if (document.getElementById('closebtn')) {
    document.getElementById('closebtn').addEventListener("click", closePopUp, false);
  }

  function closePopUp() {
    document.getElementById('bethesda-succes').classList.add('bethesda-succes--hide');
  }

  function action(e) {
    e.preventDefault();

    const formHide = document.getElementById("bethesda-form-hide");
    const formMethod = formHide.getAttribute("method");
    const formAction = formHide.getAttribute("action");
    const data = new FormData(formHide);
    data.append('external_id', data.get('email'));
    data.append('pageURL', window.location.href);
    
    const value = Object.fromEntries(data.entries());
    const dataToSend = {
      attributes: [ 
        value
      ]
    };
    const dataToSub = {
      external_id: data.get('email'),
      subscription_group_id: '8d254f38-749c-4251-8f96-0c22fa9eaa64',
      subscription_state: 'subscribed'
    };

    // console.log(JSON.stringify(dataToSend,null,'\t')); 

    function validatePhoneForE164(phoneNumber) {
      const regEx = /^\+[1-9]\d{10,14}$/;

      return regEx.test(phoneNumber);
    };

    let phoneNum = data.get('phone');
    let phoneNumToVal = phoneNum.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '');

    if (validatePhoneForE164(phoneNumToVal)){
      document.getElementById('bethesda-form-error').classList.add("hide");

      fetch(formAction, {
        method: formMethod,
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer c5218e6f-262e-41a7-939b-364f711b40c5'},
        body: JSON.stringify(dataToSend)
      })
      .then((response) => {
        console.log(response);
        if (response.ok) {
          if (data.get('phone_subscribe')){
            fetch('https://rest.iad-05.braze.com/subscription/status/set', {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer f78cdf66-0855-45dd-8946-7f68d57d9095'},
              body: JSON.stringify(dataToSub)
            })
            .then((response) => {
              console.log(response);
              if (response.ok) {
                document.getElementById('bethesda-succes').classList.remove('bethesda-succes--hide');
                formHide.reset();

                return response.json();
              }
              throw new Error('Something went wrong');
            })
            .catch((error) => console.log(error));
          } else {
            document.getElementById('bethesda-succes').classList.remove('bethesda-succes--hide');
            formHide.reset();
          }

          return response.json();
        }
        throw new Error('Something went wrong');
      })
      .catch(error => console.log(error))
    } else {
      document.getElementById('iterable-phoneNumber').classList.add("bethesda-form__item--error");
      document.getElementById('bethesda-form-error').classList.remove("hide");
    }
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-section"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  if (window.location.href.indexOf("#OnlyLoggedIn") > -1) {
    document.getElementById("assessment-reminder").classList.remove("hide");
    document.getElementById("redirectToCheckout").setAttribute('name', 'checkout_url');
    document.getElementById("redirectToCheckout").setAttribute('value', '/account#OnlyLoggedIn');
    document.getElementById("createAccount").setAttribute('href', '/account/register#OnlyLoggedIn');
  }

  if (window.location.href.indexOf("#OnlyForLoggedUsers") > -1) {
    document.getElementById("assessment-reminder").classList.remove("hide");
    document.getElementById("redirectToCheckout").setAttribute('name', 'checkout_url');
    document.getElementById("redirectToCheckout").setAttribute('value', '/checkout');
    document.getElementById("createAccount").setAttribute('href', '/account/register#OnlyForLoggedUsers');
  }

  if (window.location.href.indexOf("#from_quiz") > -1) {
    document.getElementById("assessment-reminder").classList.remove("hide");
    document.getElementById("redirectToCheckout").setAttribute('name', 'checkout_url');
    document.getElementById("redirectToCheckout").setAttribute('value', '/pages/digital-onboarding-plans/');
    document.getElementById("createAccount").setAttribute('href', '/account/register#from_quiz');

    let quizPayload = localStorage.getItem('quiz_payload');
    quizPayload = JSON.parse(quizPayload);
    const { email } = quizPayload;

    document.getElementById("emailInput").value = email;
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register-section"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  if ((window.location.href.indexOf("#OnlyLoggedIn") > -1) || (window.location.href.indexOf("#OnlyForLoggedUsers") > -1)) {
    document.getElementById("assessment-reminder").classList.remove("hide");
    document.getElementById("redirectToCheckout").setAttribute('name', 'return_to');
    document.getElementById("redirectToCheckout").setAttribute('value', '/checkout');
  }

  if (window.location.href.indexOf("#from_quiz") > -1) {
    document.getElementById("assessment-reminder").classList.remove("hide");
    document.getElementById("redirectToCheckout").setAttribute('name', 'return_to');
    document.getElementById("redirectToCheckout").setAttribute('value', '/pages/digital-onboarding-plans/');
  }

  if ((window.location.href.indexOf("#from_quiz") > -1) || (window.location.href.indexOf("#not_activated_from_quiz") > -1)) {
    let quizPayload = localStorage.getItem('quiz_payload');
    quizPayload = JSON.parse(quizPayload);

    const { first_name: firstName } = quizPayload;
    const { last_name: lastName } = quizPayload;
    const { email } = quizPayload;

    document.getElementById("emailInput").value = email;
    document.getElementsByName("customer[first_name]")[0].value = firstName;
    document.getElementsByName("customer[last_name]")[0].value = lastName;
  }
});


  } catch(e) { console.error(e); }
})();
})();
